import { getFullId, getItemId } from '@wix/thunderbolt-commons'
import { EVENT_CONTEXT_SCOPE } from './constants'
import { Model } from './types'
import { InstanceCacheFactory } from './instanceCache'
import { componentSdkFactoryArgs } from '@wix/thunderbolt-platform-types'

export type RegisterEventFactory = {
	createRegisterEvent(compId: string, controllerCompId: string, role: string | undefined): componentSdkFactoryArgs['registerEvent']
}
export function RegisterEventFactory({ handlers, models, sdkInstancesCache }: { handlers: any; models: Model; sdkInstancesCache: InstanceCacheFactory }): RegisterEventFactory {
	function getEventContext(compId: string) {
		const repeaterRoot = models.getRepeaterIdByCompId(getFullId(compId))
		if (repeaterRoot) {
			const itemId = repeaterRoot && getItemId(compId)
			return {
				type: EVENT_CONTEXT_SCOPE.COMPONENT_SCOPE,
				itemId,
				get _internal() {
					return { compId: repeaterRoot }
				}
			}
		}

		return { type: EVENT_CONTEXT_SCOPE.GLOBAL_SCOPE }
	}

	function createRegisterEvent(compId: string, controllerCompId: string, role: string) {
		return function registerEvent<EventHandler extends Function = Function>(eventName: string, eventHandler: EventHandler) {
			handlers.registerEvent(compId, eventName, (args: any) => {
				if (args[0]) {
					args[0].target = sdkInstancesCache.getSdkInstance({ compId, controllerCompId, role })
					args[0].context = getEventContext(compId)
				}
				eventHandler(...args)
			})
		}
	}

	return {
		createRegisterEvent
	}
}
